import { BoardingClassTeacher } from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    items: [],
    //
    impItems: [],
  },
  actions: {
    async fetchItems({ commit }, params) {
      const items = await BoardingClassTeacher.fetch(params)
      commit('changeState', { items })
    },
    updateByExcel(_, { id, ...params }) {
      return BoardingClassTeacher.updateByExcel(id, params)
    },
    addMany(_, { id, ...params }) {
      return BoardingClassTeacher.addMany(id, params)
    },
    removeSingle(_, { id, ...params }) {
      return BoardingClassTeacher.removeSingle(id, params)
    },
  },
  mutations: {
    setImportedItems: (state, items) => (state.impItems = items),
  },
  getters: {
    items: state => state.items,
  },
}
